module.exports = __webpack_public_path__ + "img/M0050.d6422a6b.png";